import React from 'react';

import classes from './TextLink.module.css';

interface TextLinkProps {
  text: string;
  linkText: string;
  onClick: any;
  style: React.CSSProperties;
  containerStyle: React.CSSProperties;
}

const TextLink: React.FC<TextLinkProps> = ({
  text,
  linkText,
  onClick,
  style,
  containerStyle,
}: TextLinkProps) => {
  return (
    <div className={classes.container} style={{ ...containerStyle }}>
      <p className={classes.text}>
        {text + ' '}
        <span className={classes.link} style={{ ...style }} onClick={onClick}>
          {linkText}{' '}
        </span>
      </p>
    </div>
  );
};

export default TextLink;
